import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../Utils/toastContext";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import AddressAutocomplete from "../../../Components/addressInput/address-input";

const UploadProofCorporate = ({ setCurrentStep }) => {
  const formData = useSelector((state) => state.form.formData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [accountTypeId, setAccountTypeId] = useState(null);
  const [description, setDescription] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [stockexchangeLocation, setStockexchangeLocation] = useState("");

  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const fileProofRef = useRef(null);
  const ticketFileRef = useRef(null);
  const extractDocumentFileRef = useRef(null);
  const [fileExtractDocument, setFileExtractDocument] = useState(null);
  const filePhotoGraphicIdRef = useRef(null);
  const driverLicenseFrontRef = useRef(null);
  const driverLicenseBackRef = useRef(null);
  const fileNonPhotoGraphicIdRef = useRef(null);
  const driverLicenseBackRefFirst = useRef(null);
  const driverLicenseBackRefSecond = useRef(null);
  const publicDocumentFileRef = useRef(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [abnStatus, setAbnStatus] = useState("");
  const [webLink, setWebLink] = useState("");
  const [jurisdiction, setJurisdiction] = useState("");
  const [ticketLink, setTicketLink] = useState("");
  const [abn, setAbn] = useState("");
  const fileThirdPartyRef = useRef(null);
  const financialServiceFileRef = useRef(null);
  const foreignRegistrationFileRef = useRef(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileFinancialService, setFileFinancialService] = useState(null);

  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [photoId, setphotoId] = useState(1);
  const [photoIdText, setphotoIdText] = useState("Passport");
  const [nonphotoId, setNonphotoId] = useState(1);
  const [nonphotoIdText, setNonphotoIdText] = useState("Utility Bill");
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("CV");
  const [licenseNumber, setLicenseNumber] = useState("");

  const fileCVRef = useRef(null);
  const companyRegistrationFileRef = useRef(null);

  const ticketFileLincenseRef = useRef(null);
  const driverLicenseFrontRefFirst = useRef(null);
  const driverLicenseFrontRefSecond = useRef(null);
  const [signatory, setSignatory] = useState("no");
  const [hasLicense, setHasLicense] = useState("no");
  const [ifApplicable, setIfApplicable] = useState("no");
  const [fileTicket, setFileTicket] = useState(null);

  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [fileCV, setFileCV] = useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);

  const filePhotoGraphicIdNonAusRef = useRef(null);
  const activityEvidenceRef = useRef(null);

  const filePhotoGraphicIdNonAusRefSecond = useRef(null);
  const disclosureFileRef = useRef(null);
  const adviceStatementRef = useRef(null);
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState("Passport");
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [photoIdSecondText, setphotoIdSecondText] =
    useState("Driver's License");

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);

  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);

  const [preselectedPhotograpicId, setpreselectedPhotograpicId] = useState({
    value: 1,
    label: "Passport",
  });
  const [preselectedPhotograpicIdSecond, setpreselectedPhotograpicIdSecond] =
    useState({
      value: 2,
      label: "Driver's License",
    });
  const [preselectedPersonal, setpreselectedPersonal] = useState({
    value: 1,
    label: "CV",
  });
  const [preselectedNonPhotoId, setpreselectedNonPhotoId] = useState({
    value: 1,
    label: "Utility Bill",
  });
  const [preselectedPhotograpicIdFirst, setpreselectedPhotograpicIdFirst] =
    useState({
      value: 1,
      label: "Passport",
    });

  const checkFileNameExist = (selectedFile) => {
    if (
      (fileTicket &&
        fileTicket.name.toLowerCase() === selectedFile.name.toLowerCase()) ||
      (filePublicDocument &&
        filePublicDocument.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileExtractDocument &&
        fileExtractDocument.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileLicense &&
        fileLicense.name.toLowerCase() === selectedFile.name.toLowerCase()) ||
      (fileProof &&
        fileProof.name.toLowerCase() === selectedFile.name.toLowerCase()) ||
      (fileCompanyRegistration &&
        fileCompanyRegistration.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDisclosure &&
        fileDisclosure.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileFinancialService &&
        fileFinancialService.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileForeignRegistration &&
        fileForeignRegistration.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileActivityEvidence &&
        fileActivityEvidence.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileAdviceStatement &&
        fileAdviceStatement.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceBackSecond &&
        fileDriverLinsenceBackSecond.name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceFrontSecond &&
        fileDriverLinsenceFrontSecond.name.toLowerCase() ===
          selectedFile.name.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleDeleteFileThirdParty = () => {
    setFileThirdParty(null);
    if (fileThirdPartyRef.current) {
      fileThirdPartyRef.current.value = null;
    }
  };

  const handleFileChangeThirdParty = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileThirdPartyRef.current) {
          fileThirdPartyRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileThirdParty(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileActivityEvidence = () => {
    setFileActivityEvidence(null);
    if (activityEvidenceRef.current) {
      activityEvidenceRef.current.value = null;
    }
  };
  const handleFileChangeAdviceStatement = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (adviceStatementRef.current) {
          adviceStatementRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAdviceStatement(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileAdviceStatement = () => {
    setFileAdviceStatement(null);
    if (adviceStatementRef.current) {
      adviceStatementRef.current.value = null;
    }
  };

  const handleFileChangeActivityEvidence = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (activityEvidenceRef.current) {
          activityEvidenceRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileActivityEvidence(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileForeignRegistration = () => {
    setFileForeignRegistration(null);
    if (foreignRegistrationFileRef.current) {
      foreignRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeForeignRegistration = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (foreignRegistrationFileRef.current) {
          foreignRegistrationFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileForeignRegistration(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileCompanyRegistration = () => {
    setFileCompanyRegistration(null);
    if (companyRegistrationFileRef.current) {
      companyRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeCompanyRegistration = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (companyRegistrationFileRef.current) {
          companyRegistrationFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileCompanyRegistration(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleSelectPhotographicId = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setphotoId(selectedOption.value);
    setphotoIdText(selectedOption.label);
    handleDeleteDriverLinsenceBack();
    handleDeleteDriverLinsenceFront();
    handleDeleteFileNonPhotographicId();
    handleDeleteFilePhotographicId();
    setpreselectedNonPhotoId({ value: 1, label: "Utility Bill" });
    setNonphotoId(null);
  };
  const handleSelectPhotographicIdFirst = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    if (photoIdSecond == selectedOption.value) {
      showToast(
        "The selected photographic ID is already in use. Kindly select a different document.",
        "error"
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdFirst({ ...preselectedPhotograpicIdFirst });
      }, 300);
      return;
    }
    setphotoIdFirst(selectedOption.value);
    setphotoIdFirstText(selectedOption.label);
    handleDeleteDriverLinsenceBackFirst();
    handleDeleteDriverLinsenceFrontFirst();
    handleDeleteFilePhotographicIdFirst();
    setpreselectedPhotograpicIdFirst(selectedOption);
  };
  const handleSelectPhotographicIdSecond = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    if (photoIdFirst == selectedOption.value) {
      showToast(
        "The selected photographic ID is already in use. Kindly select a different document.",
        "error"
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdSecond({
          ...preselectedPhotograpicIdSecond,
        });
      }, 300);
      return;
    }
    setphotoIdSecond(selectedOption.value);
    setphotoIdSecondText(selectedOption.label);
    handleDeleteDriverLinsenceBackSecond();
    handleDeleteDriverLinsenceFrontSecond();
    handleDeleteFilePhotographicIdSecond();
    setpreselectedPhotograpicIdSecond(selectedOption);
  };
  const handleSelectPersonal = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setPersonalDataId(selectedOption.value);
    setPersonalDataIdText(selectedOption.label);
    handleDeleteFileCV();
  };
  const handleSelectNonPhoto = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setNonphotoId(selectedOption.value);
    setNonphotoIdText(selectedOption.label);
    handleDeleteFileNonPhotographicId();
  };
  const handleDeleteFileTicket = () => {
    setFileTicket(null);
    if (ticketFileRef.current) {
      ticketFileRef.current.value = null;
    }
  };

  const handleFileChangeTicket = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (ticketFileRef.current) {
          ticketFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileTicket(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileExtractDocument = () => {
    setFileExtractDocument(null);
    if (extractDocumentFileRef.current) {
      extractDocumentFileRef.current.value = null;
    }
  };

  const handleFileChangeExtractDocument = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (extractDocumentFileRef.current) {
          extractDocumentFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileExtractDocument(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileDisclosure = () => {
    setFileDisclosure(null);
    if (disclosureFileRef.current) {
      disclosureFileRef.current.value = null;
    }
  };

  const handleFileChangeDisclosure = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (disclosureFileRef.current) {
          disclosureFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDisclosure(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileFinancialService = () => {
    setFileFinancialService(null);
    if (financialServiceFileRef.current) {
      financialServiceFileRef.current.value = null;
    }
  };

  const handleFileChangeFinancialService = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (financialServiceFileRef.current) {
          financialServiceFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileFinancialService(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileLicense = () => {
    setFileLicense(null);
    if (ticketFileLincenseRef.current) {
      ticketFileLincenseRef.current.value = null;
    }
  };

  const handleFileChangeLicense = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (ticketFileLincenseRef.current) {
          ticketFileLincenseRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileLicense(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFilePublicDocument = () => {
    setFilePublicDocument(null);
    if (publicDocumentFileRef.current) {
      publicDocumentFileRef.current.value = null;
    }
  };
  const handleFileChangePublicDocument = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (publicDocumentFileRef.current) {
          publicDocumentFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFilePublicDocument(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeProof = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileProofRef.current) {
          fileProofRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileProof(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileProof = () => {
    setFileProof(null);
    if (fileProofRef.current) {
      fileProofRef.current.value = null;
    }
  };
  const handleFileChangePhotographicId = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdRef.current) {
          filePhotoGraphicIdRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFilePhotographicId(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFront = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRef.current) {
          driverLicenseFrontRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFront(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFrontFirst = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefFirst.current) {
          driverLicenseFrontRefFirst.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFrontFirst(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFrontSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefSecond.current) {
          driverLicenseFrontRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFrontSecond(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFilePhotographicId = () => {
    setFilePhotographicId(null);
    if (filePhotoGraphicIdRef && filePhotoGraphicIdRef.current) {
      filePhotoGraphicIdRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFront = () => {
    setFileDriverLinsenceFront(null);
    if (driverLicenseFrontRef && driverLicenseFrontRef.current) {
      driverLicenseFrontRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontFirst = () => {
    setFileDriverLinsenceFrontFirst(null);
    if (driverLicenseFrontRefFirst && driverLicenseFrontRefFirst.current) {
      driverLicenseFrontRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontSecond = () => {
    setFileDriverLinsenceFrontSecond(null);
    if (driverLicenseFrontRefSecond && driverLicenseFrontRefSecond.current) {
      driverLicenseFrontRefSecond.current.value = null;
    }
  };
  const handleFileChangeDriverLincenseBack = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRef.current) {
          driverLicenseBackRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBack(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteDriverLinsenceBack = () => {
    setFileDriverLinsenceBack(null);
    if (driverLicenseBackRef && driverLicenseBackRef.current) {
      driverLicenseBackRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackFirst = () => {
    setFileDriverLinsenceBackFirst(null);
    if (driverLicenseBackRefFirst && driverLicenseBackRefFirst.current) {
      driverLicenseBackRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackSecond = () => {
    setFileDriverLinsenceBackSecond(null);
    if (driverLicenseBackRefSecond && driverLicenseBackRefSecond.current) {
      driverLicenseBackRefSecond.current.value = null;
    }
  };
  const handleFileChangeNonPhotographicId = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileNonPhotoGraphicIdRef.current) {
          fileNonPhotoGraphicIdRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setfileNonPhotographicId(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };

  const handleDeleteFileNonPhotographicId = () => {
    setfileNonPhotographicId(null);
    if (fileNonPhotoGraphicIdRef && fileNonPhotoGraphicIdRef.current) {
      fileNonPhotoGraphicIdRef.current.value = null;
    }
  };
  const handleFileChangeCV = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileCVRef.current) {
          fileCVRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileCV(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFileCV = () => {
    setFileCV(null);
    if (fileCVRef && fileCVRef.current) {
      fileCVRef.current.value = null;
    }
  };
  const handleFileChangePhotographicIdFirst = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdNonAusRef.current) {
          filePhotoGraphicIdNonAusRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setfilePhotographicIdFirst(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangePhotographicIdSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdNonAusRefSecond.current) {
          filePhotoGraphicIdNonAusRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setfilePhotographicIdSecond(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleDeleteFilePhotographicIdFirst = () => {
    setfilePhotographicIdFirst(null);
    if (filePhotoGraphicIdNonAusRef && filePhotoGraphicIdNonAusRef.current) {
      filePhotoGraphicIdNonAusRef.current.value = null;
    }
  };
  const handleDeleteFilePhotographicIdSecond = () => {
    setfilePhotographicIdSecond(null);
    if (
      filePhotoGraphicIdNonAusRefSecond &&
      filePhotoGraphicIdNonAusRefSecond.current
    ) {
      filePhotoGraphicIdNonAusRefSecond.current.value = null;
    }
  };
  const handleFileChangeDriverLincenseBackFirst = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefFirst.current) {
          driverLicenseBackRefFirst.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBackFirst(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeDriverLincenseBackSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefSecond.current) {
          driverLicenseBackRefSecond.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error"
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBackSecond(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleContinue = () => {
    handlesave();
    setCurrentStep(6);
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const handleBack = () => {
    setCurrentStep(4);
  };
  const handlesave = () => {

    dispatch(updateFormData({ field: "fileTicket", value: fileTicket }));
    dispatch(updateFormData({ field: "ticketLink", value: ticketLink }));
    dispatch(
      updateFormData({ field: "filePublicDocument", value: filePublicDocument })
    );
    dispatch(
      updateFormData({
        field: "fileCompanyRegistration",
        value: fileCompanyRegistration,
      })
    );
    dispatch(
      updateFormData({ field: "fileDisclosure", value: fileDisclosure })
    );
    dispatch(
      updateFormData({
        field: "fileExtractDocument",
        value: fileExtractDocument,
      })
    );
    dispatch(
      updateFormData({
        field: "hasLicense",
        value: hasLicense,
      })
    );
    dispatch(updateFormData({ field: "licenseNumber", value: licenseNumber }));
    dispatch(updateFormData({ field: "fileLicense", value: fileLicense }));
    dispatch(
      updateFormData({
        field: "fileForeignRegistration",
        value: fileForeignRegistration,
      })
    );
    dispatch(updateFormData({ field: "jurisdiction", value: jurisdiction }));
    dispatch(
      updateFormData({
        field: "stockexchangeLocation",
        value: stockexchangeLocation,
      })
    );
    dispatch(
      updateFormData({
        field: "fileFinancialService",
        value: fileFinancialService,
      })
    );
    dispatch(updateFormData({ field: "ifApplicable", value: ifApplicable }));
    dispatch(updateFormData({ field: "description", value: description }));
    dispatch(updateFormData({ field: "fileProof", value: fileProof }));
    dispatch(updateFormData({ field: "abn", value: abn }));
    dispatch(updateFormData({ field: "abnStatus", value: abnStatus }));
    dispatch(
      updateFormData({ field: "fileThirdParty", value: fileThirdParty })
    );
    dispatch(
      updateFormData({
        field: "fileActivityEvidence",
        value: fileActivityEvidence,
      })
    );
    dispatch(
      updateFormData({
        field: "fileAdviceStatement",
        value: fileAdviceStatement,
      })
    );
    dispatch(updateFormData({ field: "webLink", value: webLink }));
 
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <>
          <div className="bg-white shadow-md rounded-md p-4">
            <div className="border-b border-colour-custom pb-2">
              <div className="flex items-center space-x-2 mb-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
                <li>
                  Please submit all colour copies of the necessary documents.
                </li>
                <li>
                  Resubmitting the application is required if the documents are
                  not submitted in colour.
                </li>
                <li>
                  Please submit certified documents if your company is an
                  Australian company or submit Notarised documents if your
                  company is Non-Australian.
                </li>
                <li>
                  Please be advised that your application will be subjected to
                  rejection if documents submitted in this section are older
                  than three days!{" "}
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {(formData.companycategoryId == 2 ||
                  formData.companycategoryId == 3 ||
                  (formData.companycategoryId == 1 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        A search/extract of the relevant Australian stock
                        exchange
                        <span className="text-red-500">*</span>
                      </label>
                    </div>
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-[#868686]  whitespace-normal break-words block"
                    >
                      Filling one of these fields is required!
                    </label>
                    <label
                      htmlFor="refId"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Ticket Number
                    </label>
                    <input
                      id="jAccId"
                      name="jAccId"
                      type="text"
                      value={ticketLink}
                      placeholder="Enter URL"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setTicketLink(e.target.value)}
                    />
                    <label
                      htmlFor="refId"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Or File Upload
                    </label>{" "}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={ticketFileRef}
                        onChange={handleFileChangeTicket}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileTicket && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">{fileTicket.name}</span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileTicket}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                    <label
                      htmlFor="investmentType"
                      className="text-sm mt-4 text-labelColour  whitespace-normal break-words block"
                    >
                      A public document issued by the company (E.g. Annual
                      General Report)<span className="text-red-500">*</span>
                    </label>
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={publicDocumentFileRef}
                        onChange={handleFileChangePublicDocument}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {filePublicDocument && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {filePublicDocument.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFilePublicDocument}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
                {(formData.companycategoryId == 2 ||
                  (formData.companycategoryId == 1 &&
                    formData.companyTypeId == 1) ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <label
                      htmlFor="refId"
                      className={`${
                        formData.companycategoryId == 2 ||
                        formData.companycategoryId == 3
                          ? "mt-4 "
                          : ""
                      }mb-1 text-sm text-labelColour  whitespace-normal break-words block`}
                    >
                      Valid Company Registration Certificate issued by ASIC
                      <span className="text-red-500">*</span>
                    </label>{" "}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={companyRegistrationFileRef}
                        onChange={handleFileChangeCompanyRegistration}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileCompanyRegistration && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileCompanyRegistration.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileCompanyRegistration}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-labelColour  whitespace-normal break-words block mt-4"
                    >
                      Disclosure certificate verifying information about the
                      beneficial ownership of the company
                      <span className="text-red-500">*</span>
                    </label>
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={disclosureFileRef}
                        onChange={handleFileChangeDisclosure}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileDisclosure && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileDisclosure.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileDisclosure}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
                <label
                  htmlFor="investmentType"
                  className="text-sm mt-4 text-labelColour  whitespace-normal break-words block"
                >
                  A search/extract of the relevant ASIC database
                  <span className="text-red-500">*</span>
                </label>
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={extractDocumentFileRef}
                    onChange={handleFileChangeExtractDocument}
                    className="hidden"
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileExtractDocument && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <div className="flex-col flex">
                      <span className="text-black">
                        {fileExtractDocument.name}
                      </span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    <button
                      onClick={handleDeleteFileExtractDocument}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  {(formData.companycategoryId == 1 ||
                    (formData.companycategoryId == 3 &&
                      formData.companyTypeId == 1)) && (
                    <>
                      <label
                        htmlFor="investmentType"
                        className="block whitespace-normal break-words text-sm text-labelColour flex items-center"
                      >
                        Does your company possess a financial services license?
                      </label>
                      {/* Radio Buttons */}
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value="yes"
                            checked={hasLicense === "yes"}
                            onChange={(e) => setHasLicense(e.target.value)}
                            className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value="no"
                            checked={hasLicense === "no"}
                            onChange={(e) => setHasLicense(e.target.value)}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      {hasLicense == "yes" && (
                        <>
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Licence Number
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            id="jAccId"
                            name="jAccId"
                            type="text"
                            value={licenseNumber}
                            placeholder="Enter URL"
                            className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                            onChange={(e) => setLicenseNumber(e.target.value)}
                          />
                          <label
                            htmlFor="refId"
                            className="block whitespace-normal words-break mb-1 mt-4 text-sm text-labelColour"
                          >
                            Upload a search of the license or other records of
                            the relevant commonwealth, state, or Territory
                            regulator
                          </label>{" "}
                          <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                            <input
                              type="file"
                              id="fileUpload"
                              accept=".pdf,.png,.jpeg"
                              ref={ticketFileLincenseRef}
                              onChange={handleFileChangeLicense}
                              className="hidden"
                            />
                            <img
                              src="/folder-add.svg"
                              alt="Success Icon"
                              className="h-4 w-4"
                            />{" "}
                            <p className="mt-2 text-gray-500 text-sm">
                              Drag & Drop <br />
                              or{" "}
                              <span className="underline">Click to Upload</span>
                            </p>
                          </label>
                          <div className="mt-1">
                            <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PNG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              JPEG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PDF
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              &#60; 10 MB
                            </span>
                          </div>
                          {fileLicense && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div className="flex-col flex">
                                <span className="text-black">
                                  {fileLicense.name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              <button
                                onClick={handleDeleteFileLicense}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {(formData.companycategoryId == 2 ||
                    (formData.companycategoryId == 3 &&
                      formData.companyTypeId == 2)) && (
                    <>
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Valid company registration certificate issued by the
                        relevant foreign registration body
                        <span className="text-red-500">*</span>
                      </label>
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={foreignRegistrationFileRef}
                          onChange={handleFileChangeForeignRegistration}
                          className="hidden"
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileForeignRegistration && (
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div className="flex-col flex">
                            <span className="text-black">
                              {fileForeignRegistration.name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          <button
                            onClick={handleDeleteFileForeignRegistration}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        </div>
                      )}
                      <label
                        htmlFor="investmentType"
                        className="text-sm mt-4 text-labelColour whitespace-normal block md:w-auto"
                      >
                        Jurisdiction of the primary operations of the company
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="jurisdiction"
                        name="jurisdiction"
                        type="text"
                        value={jurisdiction}
                        placeholder="Enter details"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setJurisdiction(e.target.value)}
                      />
                      <div className="mt-4">
                        <label
                          htmlFor="address"
                          className="block text-sm text-labelColour whitespace-normal words-break"
                        >
                          Location of the foreign stock or equivalent exchange{" "}
                          <span className="text-red-500"> *</span>
                        </label>
                        <AddressAutocomplete
                          onSelect={(addr) => setStockexchangeLocation(addr)}
                        />
                      </div>
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block mt-4"
                      >
                        Valid Australian financial services license issued by
                        ASIC
                        <span className="text-red-500">*</span>
                      </label>
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={financialServiceFileRef}
                          onChange={handleFileChangeFinancialService}
                          className="hidden"
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileFinancialService && (
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div className="flex-col flex">
                            <span className="text-black">
                              {fileFinancialService.name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          <button
                            onClick={handleDeleteFileFinancialService}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        </div>
                      )}
                    </>
                  )}
                  <label
                    htmlFor="investmentType"
                    className="mt-4 block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    If applicable, description and proof of any current or
                    recent prosecutions and inquiries related to money
                    laundering, terrorist links, tax offenses, and corruption{" "}
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="ifApplicable"
                        value="yes"
                        checked={ifApplicable === "yes"}
                        onChange={(e) => setIfApplicable(e.target.value)}
                        className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="ifApplicable"
                        value="no"
                        checked={ifApplicable === "no"}
                        onChange={(e) => setIfApplicable(e.target.value)}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                {ifApplicable === "yes" && (
                  <>
                    <div className="mt-4">
                      <label
                        htmlFor="address"
                        className="block text-sm text-labelColour"
                      >
                        Description<span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="address"
                        rows="3"
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                        }}
                        className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                        placeholder="Add description..."
                      />
                    </div>
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-labelColour  whitespace-normal break-words block"
                    >
                      Upload Proof<span className="text-red-500">*</span>
                    </label>
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileProofRef}
                        onChange={handleFileChangeProof}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileProof && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">{fileProof.name}</span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileProof}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="flex flex-col gap-2 w-full">
                  {/* Label */}
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour whitespace-normal block md:w-auto"
                  >
                    ABN Lookup<span className="text-red-500">*</span>
                  </label>

                  {/* Input + Button Container */}
                  <div className="flex flex-col sm:flex-row w-full md:w-auto gap-2">
                    <input
                      id="jAccId"
                      name="jAccId"
                      type="text"
                      value={abn}
                      placeholder="Type Here"
                      className="rounded-lg h-[2.813rem] border focus:ring-1 focus:ring-black text-black text-base font-medium w-full px-3 py-2 focus:outline-none"
                      onChange={(e) => setAbn(e.target.value)}
                    />
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!abn) {
                          showToast("Please Enter ABN", "error");
                          return;
                        }
                        // addAccount(e);
                      }}
                      className="w-full sm:w-auto bg-black text-white font-medium py-2 px-4 rounded-lg text-xs"
                    >
                      Submit
                    </button>
                  </div>
                </div>
                <input
                  id="refId"
                  type="text"
                  value={abnStatus}
                  disabled={true}
                  className="mt-2 bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                  placeholder="ABN Status"
                />
                {(formData.companycategoryId == 1 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 1)) && (
                  <>
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Contracts with third parties to verify the intended
                        transaction<span className="text-red-500">*</span>
                      </label>
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileThirdPartyRef}
                        onChange={handleFileChangeThirdParty}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileThirdParty && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileThirdParty.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileThirdParty}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
                {(formData.companycategoryId == 2 ||
                  (formData.companycategoryId == 3 &&
                    formData.companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Evidence about the activities undertaken by the company
                        <span className="text-red-500">*</span>
                      </label>
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={activityEvidenceRef}
                        onChange={handleFileChangeActivityEvidence}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileActivityEvidence && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileActivityEvidence.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileActivityEvidence}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                    <div className="flex items-center justify-between mt-4">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Statement of Advise
                        <span className="text-red-500">*</span>
                      </label>
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={adviceStatementRef}
                        onChange={handleFileChangeAdviceStatement}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileAdviceStatement && (
                      <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                        <div className="flex-col flex">
                          <span className="text-black">
                            {fileAdviceStatement.name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        <button
                          onClick={handleDeleteFileAdviceStatement}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      </div>
                    )}
                  </>
                )}
                <label
                  htmlFor="investmentType"
                  className="text-sm mt-4 text-labelColour whitespace-normal block md:w-auto"
                >
                  Website Link
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="jAccId"
                  name="jAccId"
                  type="text"
                  value={webLink}
                  placeholder="Enter Link"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setWebLink(e.target.value)}
                />
              </div>
            </div>
          </div>
        </>
      </div>
      <footer className="mb-1 bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
          <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
        </div>

        <div className="flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          <div className="relative w-full md:w-auto flex justify-center md:justify-end">
            <button className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm">
              <span>Save as Draft</span>
            </button>
          </div>
          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};
export default UploadProofCorporate;
